import { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, Cell } from "recharts";
import { DollarSign, Users, AlertTriangle, XCircle } from "lucide-react";
import api from "../lib/api";
import { StatCard, Loader } from "../components/common";

export default function Reports() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/reports/overview").then(({ data }) => setData(data)); }, []);
  if (!data) return <Loader />;

  return (
    <div className="p-6 lg:p-8">
      <h1 className="font-heading text-5xl">Reports</h1>
      <p className="text-secondary mt-1">Business health at a glance.</p>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
        <StatCard label="MRR" value={`$${data.mrr}`} icon={DollarSign} accent testId="rep-mrr" />
        <StatCard label="Active Subs" value={data.active_subscriptions} icon={Users} testId="rep-active" />
        <StatCard label="Past Due" value={data.past_due} icon={AlertTriangle} testId="rep-pastdue" />
        <StatCard label="Failed Payments" value={data.failed_payments} icon={XCircle} testId="rep-failed" />
      </div>
      <div className="card-surface rounded-xl p-6 mt-6 max-w-2xl">
        <p className="label-xs">Active Subscriptions by Plan</p>
        <div className="h-64 mt-4">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data.revenue_by_plan}>
              <XAxis dataKey="name" stroke="#71717A" fontSize={12} tickLine={false} axisLine={false} />
              <YAxis stroke="#71717A" fontSize={12} tickLine={false} axisLine={false} allowDecimals={false} />
              <Tooltip cursor={{ fill: "rgba(255,255,255,0.04)" }} contentStyle={{ background: "#1A1A1A", border: "1px solid #333", borderRadius: 8 }} />
              <Bar dataKey="value" radius={[6, 6, 0, 0]}>{data.revenue_by_plan.map((_, i) => <Cell key={i} fill="#FF3B30" />)}</Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
